"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermsButton = exports.BannerLink = exports.BannerText = exports.ArrowIcon = exports.BannerContainer = exports.RootContainer = exports.ButtonLoaderMobile = exports.ButtonLoaderDesktop = exports.StyledButton = exports.ErrorMessage = exports.MobileNumberInput = exports.CarNumberInput = exports.InputBase = exports.MobileNumberInputContainer = exports.CarInputContainer = void 0;
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
const building_blocks_ui_typography_1 = require("@acko-tech/building-blocks.ui.typography");
exports.CarInputContainer = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Box) `
  min-height: ${(props) => (props.isDesktop ? "80px" : "85px")};
`;
exports.MobileNumberInputContainer = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Box) `
  min-height: ${(props) => (props.isDesktop ? "80px" : "85px")};
`;
exports.InputBase = building_blocks_ui_common_1.styled.input `
  border: 1px solid #c3cad2;
  border-radius: 8px;
  padding: 1em;
  font-size: 16px;
  width: 100%;
  outline: none;
  text-transform: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  -webkit-appearance: none;
  caret-color: #5e27c9;
  ::placeholder {
    line-height: 18px;
    text-transform: none;
  }
  :focus {
    border: 1px solid #4f34d2;
  }
  &::placeholder {
    color: ${(props) => (props.isDesktop ? "#8A99A9" : "#555a68")};
    font-weight: normal;
    font-size: 16px;
  }
  :focus::placeholder {
    color: transparent;
  }

  text-transform: ${(props) => props.shouldAutoCapitalize ? "uppercase" : "none"};
  cursor: pointer;
  -webkit-appearance: none;
  box-sizing: border-box;
`;
exports.CarNumberInput = (0, building_blocks_ui_common_1.styled)(exports.InputBase) ``;
exports.MobileNumberInput = (0, building_blocks_ui_common_1.styled)(exports.InputBase) `
  /* Chrome, Safari, Edge, Opera */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
    margin: 0;
  }
  /* Firefox */
  &[type="number"] {
    -moz-appearance: textfield;
  }
`;
exports.ErrorMessage = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_typography_1.Text) `
  font-weight: 500;
  font-size: ${(props) => (props.isDesktop ? "12px" : "10px")};
  width: 100%;
  color: rgb(253, 75, 68);
  margin: 0.5em 0 0 8px;
`;
exports.StyledButton = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  width: 100%;
  height: 50px;
  background: #44cb86;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0 6px;
  margin-top: 8px;
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
  box-sizing: border-box;
  ${(props) => (props.isDesktop ? `max-width: 151px` : "")}
`;
exports.ButtonLoaderDesktop = `
    width: 50px;
    height: 48px;
    transform: scaleX(0.7) scaleY(0.7);
`;
exports.ButtonLoaderMobile = `
    width: 50px;
    height: 48px;
    transform: scaleX(1) scaleY(1);
`;
exports.RootContainer = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  box-sizing: border-box;
`;
exports.BannerContainer = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  flex-direction: row;
  background: #EBF8FF;
  border-radius: 38px;
  padding: 8px 16px;
  box-sizing: border-box;
  width: fit-content;
  cursor: pointer;
`;
exports.ArrowIcon = building_blocks_ui_common_1.styled.img `
  margin-bottom: 1px;
`;
exports.BannerText = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_typography_1.Text) `
  font-weight: 500;
  color: #282E33;
`;
exports.BannerLink = (0, building_blocks_ui_common_1.styled)(exports.BannerText) `
  color: #16C2F8;
  margin-left: 8px;
`;
exports.TermsButton = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Box) `
  width: fit-content;
  color: #0091DD;
  padding: 0px 5px;
  font-size: ${(props) => (props.isDesktop ? "16px" : "14px")};
  margin-top: 28px;
  cursor: pointer;
`;
//# sourceMappingURL=car-details-widget.styles.js.map